var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparklingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.2L16.471 12.529L18.8 13.5L16.471 14.471L15.5 16.8L14.529 14.471L12.2 13.5L14.529 12.529L15.5 10.2ZM15.5 5L13 11L7 13.5L13 16L15.5 22L18 16L24 13.5L18 11L15.5 5ZM4.125 7.875L5.5 12L6.875 7.875L11 6.5L6.875 5.125L5.5 1L4.125 5.125L0 6.5L4.125 7.875ZM6.375 18.625L5.5 16L4.625 18.625L2 19.5L4.625 20.375L5.5 23L6.375 20.375L9 19.5L6.375 18.625Z",
    fill: "#0278AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklingIcon);
export default __webpack_public_path__ + "static/media/sparkling_icon.2764b7ded52d90a27c34aeebcb17697b.svg";
export { ForwardRef as ReactComponent };